// extracted by mini-css-extract-plugin
export default {"hexagon_container":"loading_hexagon_container__OE58V","hexagon":"loading_hexagon__o2SJT","rotate":"loading_rotate__Y1yBz","hexagon_text":"loading_hexagon_text__bMfpi"};